export default __webpack_public_path__ + "static/media/alien6.065b6675.png";